export const alert = {
    compoundVariants: [
        {
            color: 'error',
            variant: 'subtle',
            class: {
                title: 'text-black',
                description: 'text-black',
            },
        },
    ],
}
